import { sendRequestJson } from '@/utils'
import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'

export class BillRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async createInvoiceNominativeData(invoiceId, clientData) {
		const url = `${this.urlBase}/world/api/bill/create-nominative-invoice`
		// Assuming the backend expects a POST with a JSON payload:
		const payload = { billId: invoiceId, clientData }
		try {
			return await sendRequestJson({
				data: payload,
				url,
				method: 'POST'
			})
		} catch (error) {
			console.error('Error creating the nominative invoice:', error)
			throw error
		}
	}

	async searchClientFiscalInfo({ page = 1, q }) {
		try {
			const params = new URLSearchParams()
			params.append('page', page.toString())
			if (q) params.append('q', q)

			const url = apiUrl(`/world/api/bill-client-fiscal-infos?${params.toString()}`)

			console.log({ url, params })

			const response = await apiRequest({
				url,
				method: 'GET',
				expect: 'json'
			})

			console.log('🔎 Respuesta completa:', response.data)
			return response.data
		} catch (err) {
			console.error('Ups, algo ha ido mal obteniendo la información de la venue.', err)
			throw err
		}
	}
}

export const billRepository = new BillRepository()
